import { Text } from 'rebass';
import React from 'react';

const BodyText = props => <Text fontSize={2} fontFamily="serif" lineHeight="1.5em" mb={3} {...props} />;

export default BodyText;
